import * as userDataHelper from '../helpers/userDataHelper';
import * as localStorage from '../localStorage/localStorage';
import * as types from './actionTypes';
import * as appHelper from '../helpers/appHelper';

export function setUserData(userData) {
    return {type: types.SET_USER_DATA, userData};
}

export function setInitialUserData(project) {
    return function (dispatch) {
        return userDataHelper.setInitialUserData(project).then(userData => {
            localStorage.set("default_langauge", userData.lang);
            localStorage.set("strings", localStorage.contentData.experience.strings[userData.lang]);
            document.documentElement.setAttribute('lang',userData.lang);
            document.title = localStorage.contentData.experience.locale[userData.lang].experience_title;

            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}

export function clearBiteUserData(bite) {
    return function (dispatch, getState) {
        const state = getState();
        return userDataHelper.clearBiteUserData(state.userData,state.contentData.experience, bite).then(userData => {
            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}

export function terminateBite(bite) {
    return function (dispatch, getState) {
        const state = getState();
        return userDataHelper.terminateBite(state.userData, bite).then(userData => {
            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}

export function updateUserDataWithSuspendData() {
    return function (dispatch, getState) {
        const state = getState();

        return userDataHelper.updateUserDataWithSuspendData(state.userData, state.trackingData.suspend_data).then(userData => {
            localStorage.set("default_langauge", userData.lang);
            localStorage.set("strings", localStorage.contentData.experience.strings[userData.lang]);
            document.documentElement.setAttribute('lang',userData.lang);
            if(appHelper.isDefined(localStorage.contentData.experience.locale[userData.lang])) {
                document.title = localStorage.contentData.experience.locale[userData.lang].experience_title;
            }
            dispatch(setUserData(userData));
            //console.log(userData);
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}

export function storeUserResponse(params) {
    return function (dispatch) {
        return userDataHelper.storeUserResponse(params).then(userData => {
            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}

export function updateScreenResults(params) {
    return function (dispatch, getState) {
        const state = getState();
        return userDataHelper.updateScreenResults(state.userData, params).then(userData => {
            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}


export function updateResourceObjectResult(params) {
    return function (dispatch, getState) {
        const state = getState();
        return userDataHelper.updateResourceObjectResult(state.userData, params).then(userData => {
            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}

/*
export function collectAchievement(params) {
    return function (dispatch, getState) {
        const state = getState();
        return userDataHelper.collectAchievement(state.userData, params).then(userData => {
            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}*/

export function collectBadge(params) {
    return function (dispatch, getState) {
        const state = getState();
        return userDataHelper.collectBadge(state.userData, params).then(userData => {
            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}

export function saveNotes(params) {
    return function (dispatch, getState) {
        const state = getState();
        return userDataHelper.saveNotes(state.userData, params).then(userData => {
            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}

export function storeUserShortResponses(params) {
    return function (dispatch) {
        return userDataHelper.storeUserShortResponses(params).then(userData => {
            dispatch(setUserData(userData));
            return userData;
        }).catch(error => {
            throw(error);
        });
    };
}

export function updateExperienceLocale(lang) {

        return function (dispatch, getState) {
            const state = getState();
            if (appHelper.isDefined(lang)) {
                return userDataHelper.updateExperienceLocale(state.userData, lang).then(userData => {
                    localStorage.set("default_langauge", lang);
                    localStorage.set("strings", localStorage.contentData.experience.strings[lang]);
                    document.documentElement.setAttribute('lang', lang);
                    if (appHelper.isDefined(localStorage.contentData.experience.locale[lang])) {
                        document.title = localStorage.contentData.experience.locale[lang].experience_title;
                    }
                    dispatch(setUserData(userData));
                    return userData;
                }).catch(error => {
                    throw(error);
                });
            }else{
                return "en";
            }
        };

}



/** WEBPACK FOOTER **
 ** ./src/actions/userDataActions.js
 **/